import { useEffect, useRef } from 'react';
import { serviceLogger } from '../utils/serviceLogger';

/**
 * Custom hook to execute a callback function at regular intervals.
 * @param {Function} callback - The function to execute at each interval
 * @param {number} interval -  The time interval (in milliseconds) between executions. Default is 30 seconds
 *
 */
const usePolling = (callback, interval = 30000, immediate = false) => {
  // Ref to store the callback function so it doesn't get recreated on every render
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (!interval) return;

    const execute = async () => {
      try {
        await savedCallback.current?.();
      } catch (err) {
        serviceLogger.error('Polling callback error:', err);
      }
    };

    if (immediate) execute();

    const id = setInterval(execute, interval);
    return () => clearInterval(id);
  }, [interval, immediate]);
};

export default usePolling;
